import { useMemo } from 'react'
import { Outlet, useLocation } from 'react-router-dom'

import { Medias } from '../../../enumns/medias'
import { useMediaQuery } from '../../../hooks/useMediaQuery'
import { Sidebar } from './components/Sidebar'
import { useInfiniteProjectsQuery } from '../../../services/hooks/projects/queries/useProjectQuery'
import { MenuMobile } from './components/MenuMobile'
import { type ProjectDomain } from '../../../types/domain/project-domain'
import { useRequestQuery } from '../../../services/hooks/request/queries/useRequestsQuery'

export const ProjectsPage = () => {
  const isMinScreenWidthLG = useMediaQuery(`(min-width: ${Medias.LG}px)`)

  const location = useLocation()

  const { data, hasNextPage, isLoading, isFetchingNextPage, fetchNextPage } =
    useInfiniteProjectsQuery({
      page: 1,
      take: 10,
      search: '',
      isFiled: false,
    })

  const projects = useMemo(() => {
    return data?.pages?.reduce((acc: ProjectDomain[], { data }) => {
      return [...acc, ...data]
    }, [])
  }, [data?.pages])

  const requestIdByLocationState = (location.state as { requestId: number })?.requestId

  const { data: requestData } = useRequestQuery(requestIdByLocationState)

  return (
    <div className="relative p-6 lg:flex lg:my-8 lg:pl-7 lg:pr-0 lg:py-8 lg:gap-4">
      <div className="w-full lg:w-[240px] lg:min-w-[240px]">
        {isMinScreenWidthLG && (
          <Sidebar
            data={projects}
            hasMoreProjects={hasNextPage}
            isLoadingProjects={isLoading}
            isLoadingMoreProjects={isFetchingNextPage}
            onLoadMoreProjects={fetchNextPage}
            requestId={requestIdByLocationState}
            requestData={requestData}
          />
        )}
        {!!(
          !isMinScreenWidthLG && location.pathname === '/painel/projects'
        ) && (
          <MenuMobile
            data={projects}
            hasMoreProjects={hasNextPage}
            isLoadingProjects={isLoading}
            isLoadingMoreProjects={isFetchingNextPage}
            onLoadMoreProjects={fetchNextPage}
            requestId={requestIdByLocationState}
            requestData={requestData}
          />
        )}
      </div>

      <div className="w-full lg:w-[calc(100vw_-_308px)] lg:pl-8 lg:shadow-lg lg:grow lg:rounded-2xl lg:py-9">
        <Outlet />
      </div>
    </div>
  )
}
